import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import Landing from './pages/Landing';
import Home from './pages/Home';
import About from './pages/About';
import Browse from './pages/Browse';
import YouTube from './pages/YouTube';
import Instagram from './pages/Instagram';
import Blog from './pages/Blog';
import SubmissionForm from './pages/SubmissionForm';
import Contact from './pages/Contact';
import HealthCheck from './pages/HealthCheck';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Subscribe from './pages/Subscribe';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navigation />
        <div className="app-container">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/browse" element={<ProtectedRoute><Browse /></ProtectedRoute>} />
            <Route path="/youtube" element={<ProtectedRoute><YouTube /></ProtectedRoute>} />
            <Route path="/instagram" element={<ProtectedRoute><Instagram /></ProtectedRoute>} />
            <Route path="/blog" element={<ProtectedRoute><Blog /></ProtectedRoute>} />
            <Route path="/submission" element={<SubmissionForm />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/health" element={<HealthCheck />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Navigate to="/login" replace />} />
            <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          </Routes>
        </div>
        <footer className="app-footer">
          <p>
            &copy; 2026 SponsorBoat. All rights reserved. |{' '}
            <Link to="/privacy-policy" style={{ color: '#ccc', textDecoration: 'none' }}>Privacy Policy</Link> |{' '}
            <Link to="/terms" style={{ color: '#ccc', textDecoration: 'none' }}>Terms and Conditions</Link> |{' '}
            <Link to="/health" style={{ color: '#ccc', textDecoration: 'none' }}>System Status</Link>
          </p>
        </footer>
      </AuthProvider>
    </Router>
  );
}

export default App;
